export default __webpack_public_path__ + "static/media/icon-values_1.d74ce5ab.svg";